<template>
  <StructuredData id="schema-webpage" :schema="webPageSchema" />
  <div v-if="!initializing" class="container superior">
    <div class="row">
      <div class="col">
        <h2 class="text-primary display-5 bold text-start">{{ $t('general.avisoLegal') }}</h2>
      </div>
    </div>
    <div class="row mt-4">
      <div class="card card-body translate">
        <p v-sanitize-html="avisoLegal" class="text-primary translate"></p>
      </div>
    </div>
  </div>
</template>

<script setup>
  import { ref, onBeforeMount } from 'vue';
  import HomeApiService from '@/services/api/HomeApiService';
  import StructuredData from '@/components/utils/StructuredData.vue';
  import { useLoadingStore } from '@/store_pinia/loadingStore';
  import { usePageMeta } from '@/composables/usePageMeta';

  const loadingStore = useLoadingStore();
  const { webPageSchema } = usePageMeta();
  const initializing = ref(true);
  const avisoLegal = ref('');

  async function fetchAvisoLegal() {
    try {
      loadingStore.show();
      const response = await HomeApiService.getLegalNotice();
      avisoLegal.value = response.texto;
    } catch (error) {
      console.error('Error al obtener el aviso legal:', error);
      avisoLegal.value = '';
    } finally {
      initializing.value = false;
      loadingStore.hide();
    }
  }

  onBeforeMount(() => {
    fetchAvisoLegal();
  });
</script>

<style scoped lang="scss">
  .card-body {
    border: none;
    padding: 2rem;
  }

  .superior {
    max-width: 1200px;
    margin: 0 auto;
    padding: 25px 0;
    padding-top: 11rem;
  }

  @media only screen and (max-width: 768px) {
    .superior {
      padding: 7rem 15px;
    }

    .card-body {
      padding: 1rem;
    }
  }
</style>
